import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import * as S from './Modal.styled';
import { useAppDispatch } from 'redux/hooks';
import { setPauseRunningDate } from 'pages/app/redux';

const Modal = function Modal({
  component,
  exitOnBgClick,
  noBg,
}: { component: React.JSX.Element, exitOnBgClick?: Function, noBg?: boolean, skipSideBar?: true }) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setPauseRunningDate(true));
    return () => {
      dispatch(setPauseRunningDate(false));
    };
  }, [dispatch]);

  useEffect(() => {
    const cont = document.getElementById('content');
    const bg = document.getElementById('bgMODAL_XXY');
    if (!cont || !bg) return undefined;

    cont.style.transition = 'none';
    cont.style.bottom = 'calc(0% - 100svh)';
    cont.style.opacity = '0';
    cont.style.transform = 'translate(50%, 0%)';

    // Entrance only — do not leave transition:all on; height changes recalc
    // translateY(50%) and would animate the modal up/down (e.g. preference filters).
    const openTimer = window.setTimeout(() => {
      bg.style.opacity = '1';
      bg.style.top = '0';
      cont.style.transition = 'opacity ease-out 250ms, bottom ease-out 250ms, transform ease-out 250ms';
      cont.style.bottom = '50%';
      cont.style.transform = 'translate(50%, 50%)';
      cont.style.opacity = '1';
    }, 10);

    const settleTimer = window.setTimeout(() => {
      cont.style.transition = 'none';
    }, 280);

    return () => {
      window.clearTimeout(openTimer);
      window.clearTimeout(settleTimer);
    };
  }, []);

  return createPortal(
    <>
      <S.Bg
        onClick={() => {
          exitOnBgClick?.();
        }}
        id={noBg ? 'not-used' : 'bgMODAL_XXY'}
      />
      <S.Content id="content">
        {component}
      </S.Content>
    </>,
    document.body,
  );
};

export default Modal;
